import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  href?: string;
  ariaLabel: string;
  icon: ReactNode;
  topLine: string;
  bottomLine: string;
};

const StoreDownloadBadge = ({
  href,
  ariaLabel,
  icon,
  topLine,
  bottomLine,
}: Props) => {
  const isLink = Boolean(href?.trim());

  return (
  <Box
    component={isLink ? "a" : "div"}
    {...(isLink
      ? {
          href,
          target: "_blank",
          rel: "noopener noreferrer",
        }
      : {})}
    aria-label={ariaLabel}
    aria-disabled={!isLink}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 1,
      minWidth: 120,
      height: 40,
      px: 1.25,
      bgcolor: "#000000",
      color: "#FFFFFF",
      borderRadius: "6px",
      border: "1px solid #A6A6A6",
      textDecoration: "none",
      cursor: isLink ? "pointer" : "default",
      opacity: isLink ? 1 : 0.85,
      transition: "transform 0.15s ease, opacity 0.15s ease",
      ...(isLink
        ? {
            "&:hover": {
              opacity: 0.92,
              transform: "scale(1.02)",
            },
            "&:focus-visible": {
              outline: "2px solid",
              outlineColor: "primary.main",
              outlineOffset: 2,
            },
          }
        : {}),
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 24,
        height: 24,
        lineHeight: 0,
      }}
    >
      {icon}
    </Box>
    <Box sx={{ textAlign: "left", minWidth: 0 }}>
      <Typography
        component="span"
        sx={{
          display: "block",
          fontSize: "9px",
          fontWeight: 400,
          lineHeight: 1.15,
          letterSpacing: "0.02em",
          whiteSpace: "nowrap",
        }}
      >
        {topLine}
      </Typography>
      <Typography
        component="span"
        sx={{
          display: "block",
          fontSize: "13px",
          fontWeight: 600,
          lineHeight: 1.2,
          letterSpacing: "-0.01em",
          whiteSpace: "nowrap",
        }}
      >
        {bottomLine}
      </Typography>
    </Box>
  </Box>
  );
};

export default StoreDownloadBadge;
